// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../img/background.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Wallet_main__U-tPC {
  display: grid;
  grid-template-columns: 1.2fr 1fr;
  grid-template-rows: max-content min-content;
  gap: 3rem;
}
@media only screen and (max-width: 56.25em) {
  .Wallet_main__U-tPC {
    grid-template-rows: repeat(2, max-content) min-content;
  }
}
@media only screen and (max-width: 43.75em) {
  .Wallet_main__U-tPC {
    grid-template-columns: 100%;
    grid-template-rows: repeat(4, max-content);
  }
}
@media only screen and (max-width: 56.25em) {
  .Wallet_main__U-tPC > :last-child {
    grid-column: 1/3;
    grid-row: 2/3;
    margin-bottom: 5rem;
  }
}
@media only screen and (max-width: 43.75em) {
  .Wallet_main__U-tPC > :last-child {
    grid-column: 1/2;
    grid-row: 3/4;
  }
}
@media only screen and (max-width: 56.25em) {
  .Wallet_main__U-tPC > :nth-child(3) {
    grid-column: 1/3;
  }
}
@media only screen and (max-width: 43.75em) {
  .Wallet_main__U-tPC > :nth-child(3) {
    grid-column: 1/2;
  }
}

.Wallet_paystackButton__JIPLS {
  width: 38rem;
  border-radius: 1rem;
  background-color: var(--color-primary);
  color: var(--color-white);
  font-weight: 700;
  box-sizing: border-box;
  padding: 1.9rem 2.2rem;
  justify-content: center;
  margin-top: 2rem;
}
.Wallet_paystackButton_container__3MY9f {
  display: flex;
  justify-content: center;
}

.Wallet_wallets__E25sf {
  display: grid;
  grid-template-columns: 100%;
  gap: 2rem;
  margin-bottom: 2rem;
  width: 100%;
}

.Wallet_lowerHalf__6bO2H {
  display: grid;
  grid-template-columns: 55% 45%;
  gap: 2rem;
}
.Wallet_lowerHalf__6bO2H > :nth-child(2) > :nth-child(1) {
  margin-bottom: 2rem;
}
@media only screen and (max-width: 37.5em) {
  .Wallet_lowerHalf__6bO2H {
    grid-template-columns: 100%;
  }
  .Wallet_lowerHalf__6bO2H > :nth-child(1) {
    grid-row: 2/3;
  }
  .Wallet_lowerHalf__6bO2H > :nth-child(2) {
    grid-row: 1/2;
  }
}

.Wallet_balance__X92nW {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding: 3rem;
  border-radius: 1rem;
  background-color: var(--color-primary-3);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  transition: all 0.4s;
  width: 100%;
  height: fit-content;
}
.Wallet_balance__side__VQEiC {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.Wallet_balance__amount__C7FbD {
  display: flex;
  flex-direction: column;
}
.Wallet_balance__btns__BSISc {
  display: flex;
}
.Wallet_balance__btns__BSISc > :not(:last-child) {
  margin-right: 1rem;
}

.Wallet_card__WjW1E {
  display: flex;
  box-sizing: border-box;
  padding: 2rem;
  border-radius: 1rem;
  background-color: var(--color-white);
  background-size: cover;
  transition: all 0.4s;
  width: 100%;
  height: fit-content;
  gap: 2rem;
}
.Wallet_card_moneyIn__TVS2o {
  background-color: var(--color-primary-7);
}
.Wallet_card_moneyOut__8grTy {
  background-color: var(--color-light-red);
}

.Wallet_selectCurrency__O1O6R {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: var(--default-font-small);
  position: relative;
  margin-left: 2rem;
}
.Wallet_selectCurrency__text__GpFnX {
  display: flex;
  margin-left: 1rem;
}
.Wallet_selectCurrency__icon__S7qq3 {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 3rem;
  background-color: #f2f0f0;
  color: var(--color-primary);
  width: 5rem;
  height: 5rem;
  border-radius: 5rem;
  border: solid 1px var(--color-primary-4);
  cursor: pointer;
  transform: rotateZ(0);
  transition-duration: 500ms;
}
.Wallet_selectCurrency__icon__S7qq3:hover {
  box-shadow: 10px 10px 45px #bebebe, -15px -15px 30px #ffffff;
  background-color: var(--color-primary-3);
  transform: rotateZ(-180deg);
}
.Wallet_selectCurrency__icon_active__VqL2p {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 3rem;
  background-color: #f2f0f0;
  color: var(--color-primary);
  width: 5rem;
  height: 5rem;
  border-radius: 5rem;
  border: solid 1px var(--color-primary-4);
  cursor: pointer;
  transition-duration: 500ms;
  box-shadow: 10px 10px 45px #bebebe, -15px -15px 30px #ffffff;
  background-color: var(--color-primary-3);
  transform: rotateZ(-180deg);
}
.Wallet_selectCurrency__list__alcBW {
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  width: 5rem;
  background-color: #f2f0f0;
  color: var(--color-dark);
  border-radius: 1rem;
  box-shadow: 10px 10px 45px #bebebe, -15px -15px 30px #ffffff;
  position: absolute;
  top: 6rem;
  z-index: 30;
  border: solid 1px var(--color-primary-4);
}
.Wallet_selectCurrency__list_active__F1Yk5 {
  background-color: var(--color-primary-7);
  color: var(--color-primary);
  font-weight: 700;
}
.Wallet_selectCurrency__list__alcBW li {
  list-style: none;
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 1rem 0;
  box-sizing: border-box;
  border-radius: 1rem;
  cursor: pointer;
}
.Wallet_selectCurrency__list__alcBW li:hover {
  background-color: var(--color-primary-7);
  color: var(--color-primary);
  font-weight: 700;
}

.Wallet_exchange__PE-Hg {
  margin-top: 2rem;
  width: 40rem;
  height: 10rem;
  box-sizing: border-box;
  background-color: var(--color-table-grey-1);
  border-radius: 1rem;
  padding: 1rem 3rem;
  display: flex;
  align-items: center;
}
.Wallet_exchange__PE-Hg > :not(:last-child) {
  margin-right: 1rem;
}
.Wallet_exchange__side__HH0TT {
  display: flex;
  align-items: center;
}
.Wallet_exchange__input__uDZ\\+X {
  background-color: transparent;
  outline: none;
  border-bottom: 1px solid var(--color-dark);
  width: 15rem;
}

.Wallet_pin__z8VO\\+ {
  display: flex;
  gap: 2rem;
  margin-top: 1rem;
  padding-left: 2rem;
}
.Wallet_pin__label__Nbnsp {
  font-size: var(--default-font-small);
  font-family: inherit;
  padding-left: 4rem;
}
.Wallet_pin__group__OcgDv {
  margin: 3rem auto;
}
.Wallet_pin__item__lmO8b {
  margin-top: 0.5rem;
}

.Wallet_cancelText__I7QE- {
  text-decoration: line-through;
  color: gray;
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Wallet/Wallet.module.scss"],"names":[],"mappings":"AAEA;EACC,aAAA;EACA,gCAAA;EACA,2CAAA;EACA,SAAA;AADD;AAGC;EAND;IAOE,sDAAA;EAAA;AACF;AAEC;EAVD;IAWE,2BAAA;IACA,0CAAA;EACA;AACF;AAEE;EADD;IAEE,gBAAA;IACA,aAAA;IACA,mBAAA;EACD;AACF;AACE;EAPD;IAQE,gBAAA;IACA,aAAA;EAED;AACF;AAEE;EADD;IAEE,gBAAA;EACD;AACF;AACE;EALD;IAME,gBAAA;EAED;AACF;;AAEA;EACC,YAAA;EACA,mBAAA;EACA,sCAAA;EACA,yBAAA;EACA,gBAAA;EACA,sBAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;AACD;AACC;EACC,aAAA;EACA,uBAAA;AACF;;AAGA;EACC,aAAA;EACA,2BAAA;EACA,SAAA;EACA,mBAAA;EACA,WAAA;AAAD;;AAgBA;EACC,aAAA;EACA,8BAAA;EACA,SAAA;AAbD;AAgBE;EACC,mBAAA;AAdH;AAkBC;EAXD;IAYE,2BAAA;EAfA;EAiBA;IACC,aAAA;EAfD;EAkBA;IACC,aAAA;EAhBD;AACF;;AAoBA;EACC,aAAA;EACA,sBAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,wCAAA;EACA,yDAAA;EACA,sBAAA;EACA,oBAAA;EACA,WAAA;EACA,mBAAA;AAjBD;AAyBC;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;AAvBF;AA0BC;EACC,aAAA;EACA,sBAAA;AAxBF;AA2BC;EACC,aAAA;AAzBF;AA2BE;EACC,kBAAA;AAzBH;;AA8BA;EACC,aAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,oCAAA;EACA,sBAAA;EACA,oBAAA;EACA,WAAA;EACA,mBAAA;EACA,SAAA;AA3BD;AA6BC;EACC,wCAAA;AA3BF;AA8BC;EACC,wCAAA;AA5BF;;AAgCA;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,oCAAA;EACA,kBAAA;EACA,iBAAA;AA7BD;AA+BC;EACC,aAAA;EACA,iBAAA;AA7BF;AAgCC;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,wCAAA;EACA,eAAA;EACA,qBAAA;EACA,0BAAA;AA9BF;AAgCE;EACC,4DACC;EAED,wCAAA;EACA,2BAAA;AAhCH;AAmCE;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,wCAAA;EACA,eAAA;EACA,0BAAA;EACA,4DACC;EAED,wCAAA;EACA,2BAAA;AAnCH;AAuCC;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,sBAAA;EACA,WAAA;EACA,yBAAA;EACA,wBAAA;EACA,mBAAA;EACA,4DACC;EAED,kBAAA;EACA,SAAA;EACA,WAAA;EACA,wCAAA;AAvCF;AAyCE;EACC,wCAAA;EACA,2BAAA;EACA,gBAAA;AAvCH;AA0CE;EACC,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,WAAA;EACA,eAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;AAxCH;AA0CG;EACC,wCAAA;EACA,2BAAA;EACA,gBAAA;AAxCJ;;AA8CA;EACC,gBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,2CAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;AA3CD;AA6CC;EACC,kBAAA;AA3CF;AA8CC;EACC,aAAA;EACA,mBAAA;AA5CF;AA+CC;EACC,6BAAA;EACA,aAAA;EACA,0CAAA;EACA,YAAA;AA7CF;;AAiDA;EACC,aAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;AA9CD;AAgDC;EACC,oCAAA;EACA,oBAAA;EACA,kBAAA;AA9CF;AAiDC;EACC,iBAAA;AA/CF;AAkDC;EACC,kBAAA;AAhDF;;AAoDA;EACC,6BAAA;EACA,WAAA;EACA,iBAAA;AAjDD","sourcesContent":["@import '../variables/breakpoints';\n\n.main {\n\tdisplay: grid;\n\tgrid-template-columns: 1.2fr 1fr;\n\tgrid-template-rows: max-content min-content;\n\tgap: 3rem;\n\n\t@media only screen and (max-width: $bp-900) {\n\t\tgrid-template-rows: repeat(2, max-content) min-content;\n\t}\n\n\t@media only screen and (max-width: $bp-700) {\n\t\tgrid-template-columns: 100%;\n\t\tgrid-template-rows: repeat(4, max-content);\n\t}\n\n\t& > :last-child {\n\t\t@media only screen and (max-width: $bp-900) {\n\t\t\tgrid-column: 1/3;\n\t\t\tgrid-row: 2/3;\n\t\t\tmargin-bottom: 5rem;\n\t\t}\n\n\t\t@media only screen and (max-width: $bp-700) {\n\t\t\tgrid-column: 1/2;\n\t\t\tgrid-row: 3/4;\n\t\t}\n\t}\n\n\t& > :nth-child(3) {\n\t\t@media only screen and (max-width: $bp-900) {\n\t\t\tgrid-column: 1/3;\n\t\t}\n\n\t\t@media only screen and (max-width: $bp-700) {\n\t\t\tgrid-column: 1/2;\n\t\t}\n\t}\n}\n\n.paystackButton {\n\twidth: 38rem;\n\tborder-radius: 1rem;\n\tbackground-color: var(--color-primary);\n\tcolor: var(--color-white);\n\tfont-weight: 700;\n\tbox-sizing: border-box;\n\tpadding: 1.9rem 2.2rem;\n\tjustify-content: center;\n\tmargin-top: 2rem;\n\n\t&_container {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t}\n}\n\n.wallets {\n\tdisplay: grid;\n\tgrid-template-columns: 100%;\n\tgap: 2rem;\n\tmargin-bottom: 2rem;\n\twidth: 100%;\n\t// overflow-x: scroll;\n\n\t// &::-webkit-scrollbar {\n\t// \theight: 1rem;\n\t// \tbackground-color: var(--color-light);\n\t// \tborder-radius: 0 1rem 1rem 0;\n\t// }\n\n\t// &::-webkit-scrollbar-thumb {\n\t// \tbackground-color: var(--color-grey);\n\t// \tborder-radius: 1rem;\n\n\t// }\n}\n\n.lowerHalf {\n\tdisplay: grid;\n\tgrid-template-columns: 55% 45%;\n\tgap: 2rem;\n\n\t& > :nth-child(2) {\n\t\t& > :nth-child(1) {\n\t\t\tmargin-bottom: 2rem;\n\t\t}\n\t}\n\n\t@media only screen and (max-width: $bp-600) {\n\t\tgrid-template-columns: 100%;\n\n\t\t& > :nth-child(1) {\n\t\t\tgrid-row: 2/3;\n\t\t}\n\n\t\t& > :nth-child(2) {\n\t\t\tgrid-row: 1/2;\n\t\t}\n\t}\n}\n\n.balance {\n\tdisplay: flex;\n\tflex-direction: column;\n\tbox-sizing: border-box;\n\tpadding: 3rem;\n\tborder-radius: 1rem;\n\tbackground-color: var(--color-primary-3);\n\tbackground-image: url('../../img/background.png');\n\tbackground-size: cover;\n\ttransition: all 0.4s;\n\twidth: 100%;\n\theight: fit-content;\n\t// min-width: 50rem;\n\n\t// @media only screen and (max-width: 56.25em) {\n\t// \tpadding: 3rem 2rem;\n\t// \tmin-width: 38rem;\n\t// }\n\n\t&__side {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\t}\n\n\t&__amount {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t}\n\n\t&__btns {\n\t\tdisplay: flex;\n\n\t\t& > :not(:last-child) {\n\t\t\tmargin-right: 1rem;\n\t\t}\n\t}\n}\n\n.card {\n\tdisplay: flex;\n\tbox-sizing: border-box;\n\tpadding: 2rem;\n\tborder-radius: 1rem;\n\tbackground-color: var(--color-white);\n\tbackground-size: cover;\n\ttransition: all 0.4s;\n\twidth: 100%;\n\theight: fit-content;\n\tgap: 2rem;\n\n\t&_moneyIn {\n\t\tbackground-color: var(--color-primary-7);\n\t}\n\n\t&_moneyOut {\n\t\tbackground-color: var(--color-light-red);\n\t}\n}\n\n.selectCurrency {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tfont-size: var(--default-font-small);\n\tposition: relative;\n\tmargin-left: 2rem;\n\n\t&__text {\n\t\tdisplay: flex;\n\t\tmargin-left: 1rem;\n\t}\n\n\t&__icon {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tfont-size: 3rem;\n\t\tbackground-color: #f2f0f0;\n\t\tcolor: var(--color-primary);\n\t\twidth: 5rem;\n\t\theight: 5rem;\n\t\tborder-radius: 5rem;\n\t\tborder: solid 1px var(--color-primary-4);\n\t\tcursor: pointer;\n\t\ttransform: rotateZ(0);\n\t\ttransition-duration: 500ms;\n\n\t\t&:hover {\n\t\t\tbox-shadow:\n\t\t\t\t10px 10px 45px #bebebe,\n\t\t\t\t-15px -15px 30px #ffffff;\n\t\t\tbackground-color: var(--color-primary-3);\n\t\t\ttransform: rotateZ(-180deg);\n\t\t}\n\n\t\t&_active {\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: center;\n\t\t\talign-items: center;\n\t\t\tfont-size: 3rem;\n\t\t\tbackground-color: #f2f0f0;\n\t\t\tcolor: var(--color-primary);\n\t\t\twidth: 5rem;\n\t\t\theight: 5rem;\n\t\t\tborder-radius: 5rem;\n\t\t\tborder: solid 1px var(--color-primary-4);\n\t\t\tcursor: pointer;\n\t\t\ttransition-duration: 500ms;\n\t\t\tbox-shadow:\n\t\t\t\t10px 10px 45px #bebebe,\n\t\t\t\t-15px -15px 30px #ffffff;\n\t\t\tbackground-color: var(--color-primary-3);\n\t\t\ttransform: rotateZ(-180deg);\n\t\t}\n\t}\n\n\t&__list {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t\tbox-sizing: border-box;\n\t\twidth: 5rem;\n\t\tbackground-color: #f2f0f0;\n\t\tcolor: var(--color-dark);\n\t\tborder-radius: 1rem;\n\t\tbox-shadow:\n\t\t\t10px 10px 45px #bebebe,\n\t\t\t-15px -15px 30px #ffffff;\n\t\tposition: absolute;\n\t\ttop: 6rem;\n\t\tz-index: 30;\n\t\tborder: solid 1px var(--color-primary-4);\n\n\t\t&_active {\n\t\t\tbackground-color: var(--color-primary-7);\n\t\t\tcolor: var(--color-primary);\n\t\t\tfont-weight: 700;\n\t\t}\n\n\t\tli {\n\t\t\tlist-style: none;\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: center;\n\t\t\twidth: 100%;\n\t\t\tpadding: 1rem 0;\n\t\t\tbox-sizing: border-box;\n\t\t\tborder-radius: 1rem;\n\t\t\tcursor: pointer;\n\n\t\t\t&:hover {\n\t\t\t\tbackground-color: var(--color-primary-7);\n\t\t\t\tcolor: var(--color-primary);\n\t\t\t\tfont-weight: 700;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.exchange {\n\tmargin-top: 2rem;\n\twidth: 40rem;\n\theight: 10rem;\n\tbox-sizing: border-box;\n\tbackground-color: var(--color-table-grey-1);\n\tborder-radius: 1rem;\n\tpadding: 1rem 3rem;\n\tdisplay: flex;\n\talign-items: center;\n\n\t& > :not(:last-child) {\n\t\tmargin-right: 1rem;\n\t}\n\n\t&__side {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t}\n\n\t&__input {\n\t\tbackground-color: transparent;\n\t\toutline: none;\n\t\tborder-bottom: 1px solid var(--color-dark);\n\t\twidth: 15rem;\n\t}\n}\n\n.pin {\n\tdisplay: flex;\n\tgap: 2rem;\n\tmargin-top: 1rem;\n\tpadding-left: 2rem;\n\n\t&__label {\n\t\tfont-size: var(--default-font-small);\n\t\tfont-family: inherit;\n\t\tpadding-left: 4rem;\n\t}\n\n\t&__group {\n\t\tmargin: 3rem auto;\n\t}\n\n\t&__item {\n\t\tmargin-top: 0.5rem;\n\t}\n}\n\n.cancelText {\n\ttext-decoration: line-through;\n\tcolor: gray;\n\tfont-weight: bold;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `Wallet_main__U-tPC`,
	"paystackButton": `Wallet_paystackButton__JIPLS`,
	"paystackButton_container": `Wallet_paystackButton_container__3MY9f`,
	"wallets": `Wallet_wallets__E25sf`,
	"lowerHalf": `Wallet_lowerHalf__6bO2H`,
	"balance": `Wallet_balance__X92nW`,
	"balance__side": `Wallet_balance__side__VQEiC`,
	"balance__amount": `Wallet_balance__amount__C7FbD`,
	"balance__btns": `Wallet_balance__btns__BSISc`,
	"card": `Wallet_card__WjW1E`,
	"card_moneyIn": `Wallet_card_moneyIn__TVS2o`,
	"card_moneyOut": `Wallet_card_moneyOut__8grTy`,
	"selectCurrency": `Wallet_selectCurrency__O1O6R`,
	"selectCurrency__text": `Wallet_selectCurrency__text__GpFnX`,
	"selectCurrency__icon": `Wallet_selectCurrency__icon__S7qq3`,
	"selectCurrency__icon_active": `Wallet_selectCurrency__icon_active__VqL2p`,
	"selectCurrency__list": `Wallet_selectCurrency__list__alcBW`,
	"selectCurrency__list_active": `Wallet_selectCurrency__list_active__F1Yk5`,
	"exchange": `Wallet_exchange__PE-Hg`,
	"exchange__side": `Wallet_exchange__side__HH0TT`,
	"exchange__input": `Wallet_exchange__input__uDZ+X`,
	"pin": `Wallet_pin__z8VO+`,
	"pin__label": `Wallet_pin__label__Nbnsp`,
	"pin__group": `Wallet_pin__group__OcgDv`,
	"pin__item": `Wallet_pin__item__lmO8b`,
	"cancelText": `Wallet_cancelText__I7QE-`
};
export default ___CSS_LOADER_EXPORT___;
